export const FEATURE_KEYS = {
  MENU_PEDIDOS_ENABLED: "MENU_PEDIDOS_ENABLED",
  MENU_MAX_DIARIO_TJ_ENABLED: "MENU_MAX_DIARIO_TJ_ENABLED",
  MENU_BUZON_ENABLED: "MENU_BUZON_ENABLED",
  // Opciones de descarga del resumen de Cuenta Corriente. No son menus: son
  // opciones dentro de la pantalla, por eso el prefijo CC_ y no MENU_.
  CC_INCLUDE_BARCODE_ENABLED: "CC_INCLUDE_BARCODE_ENABLED",
  CC_INCLUDE_TALON_ENABLED: "CC_INCLUDE_TALON_ENABLED",
};

// Default opt-out: ausente (false/undefined/null) => true; solo "false" oculta.
export function isFeatureEnabledValue(raw) {
  if (raw === false || raw === undefined || raw === null) return true;
  return String(raw).toLowerCase() !== "false";
}

// Default opt-in: ausente (false/undefined/null) => false; solo "true" habilita.
export function isFeatureEnabledOptInValue(raw) {
  if (raw === false || raw === undefined || raw === null) return false;
  return String(raw).toLowerCase() === "true";
}
